import IPortIncidentsExportRequest from 'features/port/model/PortIncident/IPortIncidentsExportRequest';
import {ALL_FILTER_VALUE, dateRangeToDateAfterBefore, stringToBoolean} from 'shared/lib/filterHelper';

import type {IPortIncidentFiltersForm} from '../PortIncidentsFilters/PortIncidentsFiltersForm';

export function buildPortIncidentsExportRequest({
    portMonitor,
    resolved,
    // eslint-disable-next-line camelcase
    created_at,
    // eslint-disable-next-line camelcase
    resolved_at,
    orderBy,
}: IPortIncidentFiltersForm): IPortIncidentsExportRequest {
    const data: IPortIncidentsExportRequest = {};

    if (portMonitor && portMonitor !== ALL_FILTER_VALUE) {
        data.port_monitor_id = portMonitor;
    }

    if (resolved !== null && resolved !== undefined && resolved !== ALL_FILTER_VALUE) {
        data.resolved = stringToBoolean(resolved);
    }

    const createdAt = dateRangeToDateAfterBefore(created_at);
    if (createdAt) {
        data.created_at = createdAt;
    }

    const resolvedAt = dateRangeToDateAfterBefore(resolved_at);
    if (resolvedAt) {
        data.resolved_at = resolvedAt;
    }

    if (orderBy?.field) {
        data.order_by = orderBy;
    }

    return data;
}
